import {initialiseDatadog} from '@treatwell/ui/datadog';
import type {ErrorPattern} from '@treatwell/ui/datadog';
import {fetchConfig} from '../api/config';

let initOnce: Promise<void> | null = null;

const IGNORED_ERROR_PATTERNS: ErrorPattern[] = [
  'Skipping view transition because skipTransition() was called',
  'Transition was skipped',
];

export function initialiseDatadogWithConfig() {
  if (!initOnce) {
    initOnce = fetchConfig()
      .then((config) => {
        initialiseDatadog({
          config: {
            applicationId: 'c15d2fd1-d37e-468b-9ebc-3bcac3307b10',
            clientToken: 'pub392c208e67d3e60dfe3151d61804300a',
            site: 'datadoghq.eu',
            service: 'datetime-ui',
            version: config.version,
            env: config.twEnvName || config.environment,
          },
          options: {
            ignoredErrorPatterns: IGNORED_ERROR_PATTERNS,
          },
        });
      })
      .catch(() => {});
  }
  return initOnce;
}
